import {Component, OnInit} from '@angular/core';
import {WorkOrderService} from '../../../../Services/work-order.service';
import {BsToastService} from '../../../../Services/bs-toast-service';
import {ConfirmDialogService} from '../../../../Services/confirm-dialog.service';
import {WoCategory} from '../../../../DataModels/workorder-model';

@Component({
  selector: 'app-wo-category-list',
  templateUrl: './wo-category-list.component.html',
  standalone: false,
})
export class WoCategoryListComponent implements OnInit {

  rows: WoCategory[] = [];
  isLoaded = false;
  editingRow: Partial<WoCategory> | null = null;
  isNew = false;

  constructor(
    private woService: WorkOrderService,
    private notification: BsToastService,
    public confirmDialog: ConfirmDialogService,
  ) {
  }

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.woService.getWoCategories().subscribe({
      next: (r) => {
        this.rows = r;
        this.isLoaded = true;
      },
      error: () => {
        this.isLoaded = true;
      }
    });
  }

  startNew(): void {
    this.editingRow = {name: '', active: true, sort_order: 0};
    this.isNew = true;
  }

  startEdit(row: WoCategory): void {
    this.editingRow = {...row};
    this.isNew = false;
  }

  cancelEdit(): void {
    this.editingRow = null;
  }

  save(): void {
    if (!this.editingRow?.name) {
      return;
    }
    const obs = this.isNew
      ? this.woService.createWoCategory(this.editingRow)
      : this.woService.updateWoCategory((this.editingRow as WoCategory).id, this.editingRow);
    obs.subscribe({
      next: () => {
        this.notification.showSuccessToast('Saved.');
        this.editingRow = null;
        this.load();
      },
      error: () => {
        this.notification.showErrorToast('Error saving.');
      }
    });
  }

  delete(id: string): void {
    this.confirmDialog.confirmThis(['Delete this category?'],
      () => {
        this.woService.deleteWoCategory(id).subscribe({
          next: () => {
            this.notification.showSuccessToast('Deleted.');
            this.load();
          },
          error: () => {
            this.notification.showErrorToast('Error deleting.');
          }
        });
      }, () => {
      });
  }
}
